// import React, { useState } from "react";
// import logo from "../../../Assets/images/user_square.png";
// import styles from "./grid.module.css";
// import style from "./grid1.module.css";
// import UsersModal from "../../Modals/UsersModal/UsersModal";
// import StoreModal from "../../Modals/StoreModal/StoreModal";
// import { LazyLoadImage } from "react-lazy-load-image-component";
// import { IoPersonOutline } from "react-icons/io5";
// import Filters from "../../Common/Filters/Filters";
// import FiltersComp from "../../Common/Filters/OrderFilters";
// import PaginatorCom from "../../Paginator/PaginatorCom";
// import DeliverymanDetails from "../../../Pages/Users/Drivers/DeliverymanDetails";

// const GridTable = ({ isGrid, type, SetGridToggle, value ,fetchAllData,FilterData,handlePagination}) => {
//   // const [gridToggle, SetGridToggle] = useState(false);
//   const count = 100;
//   const per_page = 10;
//   const page = 1;
//   const [toggleUsersDetails, setToggleUsersDetails] = useState(false);
//   const [itemData, setItemData] = useState("");
//   const items =
//     value && value.data && Array.isArray(value.data.user)
//       ? value.data.user
//       : [];
//   // console.log("data in grid:", items);
//   const handleItem = (item) => {
//     setToggleUsersDetails(true);
//     setItemData(item);
//   };
//     // console.log('FileterData',FilterData);
    
//     const onPaginatorClick = (e) => {
//       if (e) {
//         // console.log("Paginator Clicked",e);
//        //  const row={
//        //   filters: null,
//        //   first: 0,
//        //   multiSortMeta: [],
//        //   page: 0,
//        //   rows: 10,
//        //   sortField: null,
//        //   sortOrder: null,
//        //   totalPages: 2   
//        // }
//        const data={
//         limit:e.rows,
//         page:+e.page+1
//        }
//        handlePagination && handlePagination(data)
//        // handlePagination && handlePagination(e.row,limit,sortOrder,filter)
//       }
    
//     };

//   // filter settings @started
//    FilterData.filters=FilterData && FilterData?.filters.filter((f)=>FilterData?.disabledFilters?!FilterData?.disabledFilters.includes(f.inputName):true)
//   // filter settings @end

//   return (
//     <>
//      <div className={styles.main}>
//      {/* <Filters
//             SetGridToggle={SetGridToggle}
//             gridToggle={isGrid}
//             type={type}
//           /> */}

//         <FiltersComp
//             layoutView={true}          
//             gridToggle={isGrid}
//             SetGridToggle={SetGridToggle}
//             filters={FilterData?.filters ? FilterData?.filters : []}
//             SearchBy={FilterData?.SearchBy?.options.length ? FilterData?.SearchBy : { options: [] }}
//             WeekRange={FilterData?.WeekRange ? FilterData?.WeekRange : false}
//             MonthRange={FilterData?.MonthRange ? FilterData?.MonthRange : false}
//             canlenderFilter={FilterData?.canlenderFilter}
//             handleFilter={(name, value) =>
//               FilterData?.handleFilter && FilterData?.handleFilter(name, value)
//             }
//             handleClearFilter={() => FilterData?.handleClearFilter && FilterData?.handleClearFilter()}
//             handleSearch={FilterData?.handleSearch ? FilterData?.handleSearch : null}
//             actionButton={
//               FilterData?.button_name &&
//               FilterData?.handleButton && {
//                 button_name: FilterData?.button_name,
//                 handleButton: FilterData?.handleButton,
//               }
//             }
//           />
//       <div className={!isGrid ? "" : style.gridContainer}>
          
       
//         {items.length > 0 ? (
//           items.map((item, index) => (
//             <div style={{ padding: "0.5rem" }} onClick={() => handleItem(item)}>
//               <div
//                 className={!isGrid ? styles.sub_container : style.sub_container}
//               >
//                 {item.profile_image ? (
//                   <LazyLoadImage
//                     src={item.profile_image}
//                     alt="img"
//                     loading="lazy"
//                     effect="blur"
//                     wrapperProps={{
//                       style: { transitionDelay: "1s" },
//                     }}
//                     className={!isGrid ? styles.img : style.img}
//                   />
//                 ) : (
//                   <img
//                     src={logo}
//                     alt=""
//                     className={!isGrid ? styles.img : style.img}
//                   />
//                 )}  

//                 <div
//                   className={
//                     !isGrid ? styles.sub_sub_container : style.sub_sub_container
//                   }
//                 >
//                   <div className="w-40">
//                     <p className="flex">
//                       <span>
//                         {item.first_name || ""}
//                         {item.last_name || ""}
//                       </span>
//                     </p>
//                     <span>{item.gender || ""}</span>
//                   </div>

//                   <div className="w-[10rem]">
//                     <p>{item.email || ""}</p>
//                     <span>{item.phone_number || ""}</span>
//                   </div>

//                   <div className={styles.price_Add}>
//                     {/* <div>Rs: 0 INR</div> */}
//                     <div className="w-[10rem] md:w-[20rem] lg:w-[30rem] whitespace-normal">{item.address || "address"} </div>
//                   </div>
//                   {item.delivery_business?.name ? (
//                     <span className={styles.resto_span}>
//                       {item.delivery_business?.name}
//                     </span>
//                   ) : (
//                     <span className={styles.resto_span}>{   type==="users"?'Customer':'Business' }</span>
//                   )}
//                 </div>
//               </div>
              
//             </div>
//           ))
//         ) : (
//           <p>No data available</p>
//         )}
//         <PaginatorCom
//           paginatorData={{
//             filters: null,
//             first: 0,
//             multiSortMeta: [],
//             page: value?.data?.page||1,
//             rows: value?.data?.limit||5,
//             sortField: null,
//             sortOrder: null,
//             totalPages: value.data?.totalPages||1  ,
//             totalCount: value.data?.totalCount||1  
//           }}
//           onPaginatorClick={onPaginatorClick}
//         />
//       </div>
      

//       {toggleUsersDetails && type === "users" && (
//         <UsersModal
//           itemData={itemData}
//           setToggleUsersDetails={setToggleUsersDetails}
//           toggleUsersDetails={toggleUsersDetails}
//         />
//       )}
//       {toggleUsersDetails && type === "drivers" && (
//         <DeliverymanDetails
//           itemData={itemData}
//           setToggleUsersDetails={setToggleUsersDetails}
//           toggleUsersDetails={toggleUsersDetails}
//         />
//       )}
//       {toggleUsersDetails && type === "store" && (
//         <StoreModal
//           itemData={itemData}
//           setToggleUsersDetails={setToggleUsersDetails}
//           toggleUsersDetails={toggleUsersDetails}
//           fetchAllData={fetchAllData}
//         />
//       )}
//       </div>
//     </>
//   );
// };

// export default GridTable;


import React, { useState } from "react";
import logo from "../../../Assets/images/user_square.png";
import UsersModal from "../../Modals/UsersModal/UsersModal";
import StoreModal from "../../Modals/StoreModal/StoreModal";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { IoPersonOutline } from "react-icons/io5";
import FiltersComp from "../../Common/Filters/OrderFilters";
import PaginatorCom from "../../Paginator/PaginatorCom";
import DeliverymanDetails from "../../../Pages/Users/Drivers/DeliverymanDetails";

const GridTable = ({ isGrid, type, SetGridToggle, value, fetchAllData, FilterData, handlePagination }) => {
  const [toggleUsersDetails, setToggleUsersDetails] = useState(false);
  const [itemData, setItemData] = useState("");
  const items = value && value.data && Array.isArray(value.data.user) ? value.data.user : [];

  const handleItem = (item) => {
    setToggleUsersDetails(true);
    setItemData(item);
  };

  const onPaginatorClick = (e) => {
    if (e) {
      const data = {
        limit: e.rows,
        page: +e.page + 1
      };
      handlePagination && handlePagination(data);
    }
  };

  FilterData.filters = FilterData && FilterData?.filters.filter((f) =>
    FilterData?.disabledFilters ? !FilterData?.disabledFilters.includes(f.inputName) : true
  );

  return (
    <div className="w-full p-4">
      <FiltersComp
        layoutView={true}
        gridToggle={isGrid}
        SetGridToggle={SetGridToggle}
        filters={FilterData?.filters ? FilterData?.filters : []}
        SearchBy={FilterData?.SearchBy?.options.length ? FilterData?.SearchBy : { options: [] }}
        WeekRange={FilterData?.WeekRange ? FilterData?.WeekRange : false}
        MonthRange={FilterData?.MonthRange ? FilterData?.MonthRange : false}
        canlenderFilter={FilterData?.canlenderFilter}
        handleFilter={(name, value) => FilterData?.handleFilter && FilterData?.handleFilter(name, value)}
        handleClearFilter={() => FilterData?.handleClearFilter && FilterData?.handleClearFilter()}
        handleSearch={FilterData?.handleSearch ? FilterData?.handleSearch : null}
        actionButton={
          FilterData?.button_name &&
          FilterData?.handleButton && {
            button_name: FilterData?.button_name,
            handleButton: FilterData?.handleButton,
          }
        }
      />

      <div className={!isGrid ? "flex flex-col gap-4 w-full" : "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4"}>
        {items.length > 0 ? (
          items.map((item, index) => (
            <div
              key={index}
              className="cursor-pointer transition-all duration-300 rounded-lg overflow-hidden hover:-translate-y-1 hover:shadow-md"
              onClick={() => handleItem(item)}
            >
              <div className={`flex ${!isGrid ? "flex-row items-center" : "flex-col"} gap-4 p-4 bg-white rounded-lg shadow-sm`}>
                {item.profile_image ? (
                  <LazyLoadImage
                    src={item.profile_image}
                    alt="profile"
                    loading="lazy"
                    effect="blur"
                    wrapperProps={{ style: { transitionDelay: "1s" } }}
                    className="w-16 h-16 rounded-full object-cover"
                  />
                ) : (
                  <div className="w-16 h-16 rounded-full bg-gray-100 flex items-center justify-center">
                    <IoPersonOutline className="text-2xl text-gray-500" />
                  </div>
                )}

                <div className={`flex ${!isGrid ? "flex-row flex-wrap items-center gap-6" : "flex-col gap-2"} w-full`}>
                  <div className="min-w-[150px] flex-1">
                    <p className="font-semibold text-gray-800">
                      {item.first_name || ""} {item.last_name || ""}
                    </p>
                    <span className="text-sm text-gray-500">{item.gender || ""}</span>
                  </div>

                  <div className="min-w-[150px] flex-1">
                    <p className="font-medium text-gray-700 break-all">{item.email || ""}</p>
                    <span className="text-sm text-gray-500">{item.phone_number || ""}</span>
                  </div>

                  <div className="min-w-[200px] flex-[2]">
                    <div className="text-sm text-gray-600 leading-snug">
                      {item.address || "No address provided"}
                    </div>
                  </div>

                  <div className="min-w-[120px]">
                    {item.delivery_business?.name ? (
                      <span className="text-sm px-2 py-1 rounded bg-gray-100">
                        {item.delivery_business?.name}
                      </span>
                    ) : (
                      <span className="text-sm px-2 py-1 rounded bg-gray-100">
                        {type === "users" ? 'Customer' : 'Business'}
                      </span>
                    )}
                  </div>
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className="text-center py-8 text-gray-500">
            <p>No data available</p>
          </div>
        )}

        <div className="mt-8 flex justify-center w-full bg-transparent">
          <PaginatorCom
            paginatorData={{
              filters: null,
              first: 0,
              multiSortMeta: [],
              page: value?.data?.page || 1,
              rows: value?.data?.limit || 5,
              sortField: null,
              sortOrder: null,
              totalPages: value.data?.totalPages || 1,
              totalCount: value.data?.totalCount || 1
            }}
            onPaginatorClick={onPaginatorClick}
          />
        </div>
      </div>

      {toggleUsersDetails && type === "users" && (
        <UsersModal
          itemData={itemData}
          setToggleUsersDetails={setToggleUsersDetails}
          toggleUsersDetails={toggleUsersDetails}
        />
      )}
      {toggleUsersDetails && type === "drivers" && (
        <DeliverymanDetails
          itemData={itemData}
          setToggleUsersDetails={setToggleUsersDetails}
          toggleUsersDetails={toggleUsersDetails}
        />
      )}
      {toggleUsersDetails && type === "store" && (
        <StoreModal
          itemData={itemData}
          setToggleUsersDetails={setToggleUsersDetails}
          toggleUsersDetails={toggleUsersDetails}
          fetchAllData={fetchAllData}
        />
      )}
    </div>
  );
};

export default GridTable;